import type { Board } from "../board";
import { CollectableItem, type CollectablePickupResult } from "../collectableItem";
import { Event } from "../events/event";
import { EventParameter } from "../events/eventParameter";
import { EventType } from "../events/eventType";
import type { Player } from "../player";

export class PowerPlantKeyCard extends CollectableItem {
	static key = "PowerPlantKeyCard";

	pickupBy(player: Player, board: Board): CollectablePickupResult {
		player.inventory.addItem(this);
		board.stats.recordItemCollected(PowerPlantKeyCard.key, this.count);

		const event = new Event(EventType.GOT_ITEM);
		event.setParameter(EventParameter.AMMO_AMOUNT, String(this.count));
		event.setParameter(EventParameter.AMMO_NAME, this.getNameKey());
		board.addEvent(event);

		return { pickupKey: PowerPlantKeyCard.key, amount: this.count, isInfinite: false };
	}

	static deserialize(data: any): PowerPlantKeyCard {
		return new PowerPlantKeyCard(data.count);
	}
}
